const ja = {
    nav: {
      home: "ホーム",
      browse: "結婚式を探す",
      dashboard: "ダッシュボード",
      messages: "メッセージ",
      profile: "プロフィール",
      login: "ログイン",
      register: "登録",
      logout: "ログアウト",
      admin: "管理者",
      faq: "よくある質問",
      about: "私たちについて",
      contact: "お問い合わせ",
      pricing: "料金",
      howItWorks: "使い方",
    },
    auth: {
      login: {
        title: "おかえりなさい",
        email: "メールアドレス",
        password: "パスワード",
        button: "ログイン",
        noAccount: "アカウントをお持ちでないですか？",
        register: "今すぐ登録",
      },
      register: {
        title: "アカウント作成",
        name: "フルネーム",
        email: "メールアドレス",
        password: "パスワード",
        role: "希望...",
        roleHost: "結婚式を主催する",
        roleGuest: "結婚式に参加する",
        terms: "利用規約とプライバシーポリシーに同意します",
        button: "登録",
        hasAccount: "すでにアカウントをお持ちですか？",
        login: "ログインする",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "読み込み中...",
      error: "エラーが発生しました",
      success: "成功",
      save: "保存",
      cancel: "キャンセル",
      delete: "削除",
      edit: "編集",
      back: "戻る",
      next: "次へ",
      language: "言語",
      currency: "通貨",
      search: "検索",
      filter: "フィルター",
      all: "すべて",
      none: "なし",
      yes: "はい",
      no: "いいえ",
    },
    footer: {
      about: "私たちについて",
      privacy: "プライバシー",
      terms: "利用規約",
      contact: "お問い合わせ",
      copyright: "© 2024 WEDVAYA. All rights reserved.",
    },
  };

export default ja;
